'use strict';

const Immutable = require('immutable');

var React = require('react');
var Picture = require('../elements/Picture');
var SVTPlayer = require('../elements/SVTPlayer.jsx');

var ArticleTextContent = require('./EditorialTextContent.jsx');
var ArticleMediaText = require('./EditorialMediaText.jsx');
var LinkButton = require('../elements/LinkButton.jsx');
var LatestEpisodes = require('../episodes/LatestEpisodes.jsx');
var ChannelText = require('../elements/ChannelText.jsx');

var EditorialEpisodes = React.createClass({
	displayName: 'EditorialEpisodes',
	
	shouldComponentUpdate: function(nextProps) {
		return !Immutable.is(this.props.article, nextProps.article);
	},

	render: function() {

		if (!this.props.article || this.props.article.isEmpty()) {
			return false;
		}
		
		const article = this.props.article.toJS();

		if(!article.program) {
			return false;
		}

		return (
			<div className="svtse_editorial__episodes-col">
				<div className="svtse_editorial__episodes-header-col">
					<h2 className="svtse_editorial__episodes-header">
						{article.vignette}
					</h2>
					<h3 className="svtse_editorial__episodes-shortdescription">
						{article.program.shortDescription}
					</h3>
					<div className="svtse_editorial__episodes-program-link">
						<LinkButton program={article.program}>
							Om programmet
						</LinkButton>

					</div>
				</div>
				<LatestEpisodes program={article.program} />
			</div>
		);
	}
});

class Editorial extends React.Component {
	
	shouldComponentUpdate(nextProps) {
		return !Immutable.is(this.props.article, nextProps);
	}

	render() {

		if (!this.props.article || this.props.article.isEmpty()) {
			return false;
		}

		const article =	this.props.article.toJS();

		var hasVideo = article.clips && article.clips.length;
		var ArticleCover;


		var broadcastTime;
		var broadcastChannel;

		if (article.program && article.program.broadcastChannel) {
			broadcastTime = article.program.broadcastTime;
			broadcastChannel = article.program.broadcastChannel;
		}

		if (hasVideo) {
			ArticleCover = <SVTPlayer model={article.clips[0]}/>;
		} else {
			ArticleCover = <Picture className="svtse_editorial__media-fig" model={article.cover} type="extralarge" captionClass="svtse_editorial__media-caption" />;
		}

		return (
			<section className="svtse_editorial">
				<article className="svtse_editorial__article" ref="editorialArticle">

					<div className="svtse_editorial__container">
						<div className="svtse_editorial__row">
							<div className="svtse_editorial__top">
								<div className="svtse_editorial__vignette-col">
									<h2 className="svtse_editorial__vignette">
										{article.vignette}
									</h2>
								</div>

								<div className="svtse_editorial__broadcast-info-col">
									<span className="svtse_editorial__broadcast-channel">
										<ChannelText channel={broadcastChannel} />
									</span>
									<time className="svtse_editorial__broadcast-date">
										{broadcastTime}
									</time>
								</div>
							</div>

							<div className="svtse_editorial__headline">
								<div className="svtse_editorial__headline-col">
									<h1 className="svtse_editorial__headline-text">
										{article.title}
									</h1>
								</div>
							</div>
						</div>
					</div>

					<div className="svtse_editorial__media">
						<div className="svtse_editorial__container">
							<div className="svtse_editorial__row">
								<div className="svtse_editorial__cover">
									{ArticleCover}
								</div>
							</div>
						</div>
					</div>

					<div className="svtse_editorial__container">
						<div className="svtse_editorial__row">
							<div className="svtse_editorial__bottom">
								<ArticleMediaText article={article} />

								<div className="svtse_editorial__content">
									<div className="svtse_editorial__text-col">
										<ArticleTextContent article={article} />
									</div>
								</div>

							</div>
						</div>

						<EditorialEpisodes article={this.props.article} />

					</div>
				</article>
			</section>
		);
	}
}

export default Editorial;



/** WEBPACK FOOTER **
 ** ./app/components/Editorial/index.js
 **/